import { CornerTag } from '@/monitoring/MonitoringOverview/Components';
import { ReportSectionStyled } from '@/reports/shared/ReportSection/ReportSection';
import { Button, Box, Text, Icons } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

export interface VehicleTitleRegistrationsProps {
  icon?: string;
  sectionId: string;
  sectionName: string;
  reportUpgraded: boolean;
  nmvtisSuccess: boolean | undefined;
  handleFreeUpgrade: () => void;
}

/**
 * This component is responsible for providing users with the ability to upgrade the report and view more available data.
 */

export const PremiumSection = ({
  icon,
  sectionId,
  sectionName,
  reportUpgraded,
  nmvtisSuccess,
  handleFreeUpgrade,
}: VehicleTitleRegistrationsProps) => {
  const { isMobile } = useScreenSize();

  return (
    <ReportSectionStyled
      id={sectionId}
      flexDirection="column"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ position: 'relative' }}
    >
      <CornerTag color="info" label="PREMIUM" className="badge" />
      <Box
        mb={isMobile ? 2 : 0}
        mr={isMobile ? 0 : 2}
        data-testid={`${sectionId}-image`}
      >
        <img src={icon} alt="Premium Data" />
      </Box>
      <Text variant="h1" sx={{ mt: 2 }} data-testid={`${sectionId}-title`}>
        {sectionName}
      </Text>
      <Text
        variant="body1"
        sx={{ mb: 2 }}
        data-testid={`${sectionId}-description`}
      >
        Upgrade report to premium for FREE to see {sectionName} and all other
        premium data
      </Text>
      {reportUpgraded && !nmvtisSuccess && (
        <Text
          variant="h5"
          color="error"
          display="flex"
          alignItems="center"
          m={0}
          mb={2}
        >
          <Icons.Warning color="error" fontSize="small" sx={{ mr: 1 }} />
          Report upgrade failed. Please try again.
        </Text>
      )}
      <Button
        variant="contained"
        onClick={handleFreeUpgrade}
        color="success"
        data-testid={`${sectionId}-button`}
      >
        View FREE premium data
      </Button>
    </ReportSectionStyled>
  );
};
